export type InstanceFilters = {
  serviceLevel: string;
  version: string;
}

export const defaultInstanceFilters = {
  serviceLevel: "",
  version: ""
}